export default [
  {
    path: '/galleries',
    name: 'Galleries Listing',
    component: () => import(/* webpackChunkName: "gallery-listing" */ '../components/galleries/GalleriesListing.vue'),
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/galleries/:id',
    name: 'Gallery Edit',
    component: () =>
      import(/* webpackChunkName: "gallery-edit" */ '../components/galleries/GalleryEdit.vue'),
    meta: {
      requiresAuth: true
    },
  },

  // categorias
  {
    path: '/gallery-categories',
    name: 'Gallery Categories Listing',
    component: () => import(/* webpackChunkName: "gallery-category-listing" */ '../components/galleries/GalleryCategoriesListing.vue'),
    meta: {
      requiresAuth: true
    },
  },
  // categorias
  {
    path: '/gallery-categories/:id',
    name: 'Gallery Categories Edit',
    component: () => import(/* webpackChunkName: "gallery-category-listing" */ '../components/galleries/GalleryCategoriesEdit.vue'),
    meta: {
      requiresAuth: true
    },
  },
];